// Report Composer — 공개(무인증) surface용 결재란 데이터 빌더.
//
// 공유 응답(`ShareReportResponse`)과 외부 결재 응답(`ExternalSignatureReportView`)은 계약이
// 코어 입력(`ApprovalBlockSource`)과 같은 형상이라(작성 서명 `authorSignature{signerName,signedAt,
// signatureData}` · 위임 담당자 `delegatedContact` · 최신 round 서명)
// 어댑터 없이 그대로 코어에 넘긴다. 규칙은 rc 코어 하나(`@safetyhub/report-composer`의
// `buildApprovalBlockData`)가 소유한다 — surface가 갈라지면 한쪽만 고쳐진다(F-25). 패리티는
// `__tests__/composerApprovalDataPublic.test.ts`가 잰다.

import { buildApprovalBlockData, type ApprovalBlockData } from '@safetyhub/report-composer';
import type {
  ShareReportResponse,
  ExternalSignatureReportView,
} from '@safetyhub/shared';

/**
 * 공유 응답(`GET /share/:token`)에서 Composer 결재란 데이터를 빌드한다.
 * 공유 보고서는 결재 완료(APPROVED)라 보통 서명을 보인다.
 *
 * ⚠️ DRAFT가 이 빌더로 오는 자리가 하나 있다 — **확정 전 인쇄 미리보기**
 * (`pages/reports/[id]/composed-print-preview.tsx`). 위임본이면 그 시점에 이미 담당자의 작성
 * 완료 서명이 확정돼 있으므로 코어가 author*를 `shouldHideAuthoringSignature`로 가른다(F-25).
 */
export function buildComposerApprovalDataFromShare(
  data: ShareReportResponse,
): ApprovalBlockData {
  return buildApprovalBlockData(data);
}

/**
 * 외부 결재 응답(`/approval/:token` 등)에서 Composer 결재란 데이터를 빌드한다.
 * approvalSignatures는 서버가 이미 최신 라운드만 내려주지만 코어의 최신 round 필터는 멱등이라
 * 그대로 통과한다(세 surface가 같은 코드를 탄다).
 */
export function buildComposerApprovalDataFromExternal(
  report: ExternalSignatureReportView,
): ApprovalBlockData {
  return buildApprovalBlockData(report);
}
